import type {
  FeatureFlagClientConfigurationMap,
  FeatureFlagConfirmationDialogContent,
  FeatureFlagMetadataFormValues,
  FeatureFlagPendingConfirmation,
  FeatureFlagTargetClient,
} from '../../../types/features/featureFlags';
import {
  FEATURE_FLAG_CLIENT_LABELS,
  FEATURE_FLAG_CONFIRMATION_COPY,
} from '../constants/featureFlagOptions';

export const EMPTY_FEATURE_METADATA_VALUES: FeatureFlagMetadataFormValues = {
  description: '',
  displayName: '',
  featureKey: '',
};

export const CREATE_ASSIGNMENTS_ERROR_MESSAGE = 'Feature created, but assignments failed to save.';

export const UPDATE_ASSIGNMENTS_ERROR_MESSAGE = 'Feature updated, but assignments failed to save.';

export const getSubmitErrorMessage = (error: unknown, fallbackMessage: string): string => {
  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallbackMessage;
};

export const getSelectedFeatureFlagTargetClient = (
  clientConfigurations: FeatureFlagClientConfigurationMap,
): FeatureFlagTargetClient | null => (
  clientConfigurations.webapp.selected ? 'webapp' : clientConfigurations.mobile_app.selected ? 'mobile_app' : null
);

export const getFeatureFlagConfirmationDialogContent = (
  pendingConfirmation: FeatureFlagPendingConfirmation | null,
): FeatureFlagConfirmationDialogContent | null => {
  if (!pendingConfirmation) {
    return null;
  }

  const confirmationCopy = FEATURE_FLAG_CONFIRMATION_COPY[pendingConfirmation.type];
  const clientLabel = FEATURE_FLAG_CLIENT_LABELS[pendingConfirmation.client];

  return {
    confirmButtonText: confirmationCopy.confirmButtonText,
    confirmTone: confirmationCopy.confirmTone,
    message: confirmationCopy.messageTemplate.replace('{clientLabel}', clientLabel),
    title: confirmationCopy.title,
  };
};
